import React, { Component } from "react";
import { graphql } from "react-apollo";
import { mutationLogout } from "Apollo";
import { ShowNotice } from "Store";
import IconMenu from "./IconMenu";

export default graphql(mutationLogout)(
  class LogoutMenu extends Component {
    render() {
      return (
        <IconMenu
          key="logout"
          name="logout"
          icon="sidebar-logout"
          iconSelected="sidebar-logout-selected"
          tooltip="Logout"
          onClick={this.onClick}
        />
      );
    }

    onClick = async () => {
      try {
        await this.props.mutate();
      } catch (error) {
        ShowNotice("logout-error");
      }
      window.location = "/login";
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-sidemenu/LogoutMenuWithMutation.js